export const OrgType = {
  MEDIA_AGENCY: "MEDIA_AGENCY",
  MEDIA_OWNER: "MEDIA_OWNER",
  BRAND_OWNER: "BRAND_OWNER",
  OTHER: "OTHER",
};
